import { UIText3 } from '@cian/ui-kit';
import { AgentWorkHonestlyProofs } from '../../components/AgentWorkHonestlyProofs';

import { usePublisher } from '../../hooks';

export const AgentWorkHonestlyProofsContainer = () => {
  const {
    labels: { isIdentifiedByDocument, agentInfo },
  } = usePublisher();

  if (!isIdentifiedByDocument) {
    return null;
  }

  return (
    <>
      {isIdentifiedByDocument && <AgentWorkHonestlyProofs message="Документы проверены" />}
      {agentInfo && <UIText3 color="gray60_100">{agentInfo}</UIText3>}
    </>
  );
};
